import React, { useEffect, useRef, useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import { BrowserRouter, useNavigate, Link, Route, Routes, Switch } from "react-router-dom";
import Nav from '../Components/Nav';
import Sidebar from '../Components/Sidebar';
import { f, database, storage, auth } from "../config";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import firebase from "firebase";
import Swal from 'sweetalert2'
import axios from 'axios'


function Deposit() {
  const history = useNavigate();
  const [{ userdetails, loggedin, tradingpair, depositinfo }, dispatch] = useContext(GlobalContext);
  const [loading, setloading] = useState(false)
  const [step, setstep] = useState(1)

  // ── Coins are fetched live from Firestore so admin changes reflect immediately ──
  const [Coins, setCoins] = useState([]);
  const [coinsLoaded, setcoinsLoaded] = useState(false);

  useEffect(() => {
    adminfetchall();
  }, []);

  const adminfetchall = async () => {
    try {
      const snapshot = await db.collection("allcoins").get();
      const list = [];
      snapshot.forEach((doc) => {
        const coin = doc.data();
        coin.id = doc.id;
        // Only show coins the admin has NOT disabled
        if (coin.active !== false) {
          list.push(coin);
        }
      });
      setCoins(list);
      setcoinsLoaded(true);
    } catch (err) {
      console.error("Error fetching coins:", err);
      setcoinsLoaded(true);
    }
    setloading(false)
  };

  useEffect(() => {
    if (loggedin) {
      console.log(userdetails);
      console.log(userdetails.email);
      setloading(false)
    } else {
      f.auth().onAuthStateChanged(function (user) {
        if (user) {
          var userid = f.auth().currentUser;
          var userids = userid.uid;
          fetchuserdata(userids);
          setloggedin(true);
        } else {
          setloggedin(false);
          setloading(false)
          history("/");
        }
      });
    }
  }, []);

  const fetchuserdata = async (userid) => {
    var docRef = db.collection("users").doc(userid);
    await docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          setdetails(doc.data());
          setloading(false)
        } else {
          console.log("No such document!");
          setloading(false)
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  };

  const setdetails = (data) => {
    dispatch({ type: "setuserdetails", snippet: data });
  };

  const setloggedin = (data) => {
    dispatch({ type: "setloggedin", snippet: data });
  };

  const [CoinInfo, setCoinInfo] = useState({})
  const [Amount, setAmount] = useState(0)
  const [image, setimage] = useState(null);
  const [url, seturl] = useState("");
  const [progress, setprogress] = useState(0);
  const [imagepresnt, setimagepresent] = useState(false);
  const [prevfile, setprevFile] = useState("")

  const Proceed = () => {
    if (!Amount || Amount == 0 || !CoinInfo || !CoinInfo.name) {
      Swal.fire({
        icon: 'error',
        title: 'NO Amount Or Coin Selected',
        text: 'Insert A valid Amount and Select a coin',
      })
      return
    }
    setstep(2)
  }

  // ── Single handler: looks up the coin by name from the live Firestore array ──
  const SetCoinInfo = (coinName) => {
    const found = Coins.find(o => o.name === coinName);
    if (found) {
      setCoinInfo(found);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: `You Selected ${found.name} as Payment Method`,
        showConfirmButton: false,
        timer: 1500
      })
    }
  }

  const copyAlert = () => {
    navigator.clipboard.writeText(CoinInfo.address);
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: `${CoinInfo.name} Address Was Copied Please Proceed To Payment`,
      showConfirmButton: false,
      timer: 1500
    })
  }

  const handleChange = (e) => {
    if (e.target.files[0]) {
      setimage(e.target.files[0]);
      setimagepresent(true);
      setprevFile(URL.createObjectURL(e.target.files[0]))
    }
  };

  const handleUpload = async () => {
    if (!imagepresnt) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No Image Was Selected!',
      })
      return
    }

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'profouihdnb');   // ← Change to your Cloudinary upload preset

    try {
      setprogress(0);

      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/dtivcyoor/image/upload`,  // ← Change YOUR_CLOUD_NAME
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setprogress(percent);
          }
        }
      );

      const uploadedUrl = res.data.secure_url;

      seturl(uploadedUrl);
      updatehistory(uploadedUrl);
      setprogress(0);
      setimagepresent(false);
      
      Swal.fire(
        'Succesful Transaction!',
        'Your account will be credited once the payment is recieved.',
        'success'
      );
      setimage(null);

    } catch (error) {
      console.error("Cloudinary upload error:", error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: 'Failed to upload payment proof. Please try again.',
      });
      setprogress(0);
    }
  };

  const CreatUserObj = async (obj) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    let uobj = {
      fullname: userdetails.fullname,
      email: userdetails.email,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      userid: userids,
      info: obj
    };
    await db
      .collection("deposits")
      .add(uobj)
      .then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };

  const updatehistory = async (urls) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    const increment = firebase.firestore.FieldValue.increment(parseInt(Amount));
    CreatUserObj({
      image: urls,
      date: Date.now(),
      amt: Amount,
      mode: "Deposit",
      coin: CoinInfo.name
    })
    var washingtonRef = db.collection("users").doc(userids);
    await washingtonRef.update({
      Totaldeposit: increment,
      Deposithistory: firebase.firestore.FieldValue.arrayUnion({
        image: urls,
        date: Date.now(),
        amt: Amount,
        mode: "Deposit",
        coin: CoinInfo.name
      }),
    });
  };

  return (
    <div>
      <div>
        <div className="container-fluid container-application">
          {/* Sidenav */}
          <Nav />
          {/* Content */}
          <div className="main-content position-relative">
            {/* Main nav */}
            <nav className="navbar navbar-main navbar-expand-lg navbar-dark bg-primary navbar-border" id="navbar-main">
              <div className="container-fluid">
                <div className="pl-4 d-block d-md-none">
                  <a className="navbar-brand" href="/dashboards">
                    <img src="/assets/images/logo/logo.png" className="navbar-brand-img" alt="..." />
                  </a>
                </div>
                <div className="ml-auto navbar-user d-lg-none">
                  <ul className="flex-row navbar-nav align-items-center">
                    <li className="nav-item">
                      <a href="#" className="nav-link nav-link-icon sidenav-toggler" data-action="sidenav-pin" data-target="#sidenav-main"><i className="far fa-bars" /></a>
                    </li>
                    <li className="nav-item dropdown dropdown-animate">
                      <a className="nav-link pr-lg-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="avatar avatar-sm rounded-circle">
                          <i className="fas fa-user-circle fa-2x" />
                        </span>
                      </a>
                      <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right dropdown-menu-arrow">
                        <h6 className="px-0 dropdown-header">Hi, {userdetails.fullname}!</h6>
                        <a href="/Dashboard/account-settings" className="dropdown-item">
                          <i className="far fa-user" />
                          <span>My profile</span>
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item text-danger" href="https://getonlinetrader.pro/otprocl/logout" onClick={(e) => { e.preventDefault(); document.getElementById('logout-form').submit(); }}>
                          <i className="far fa-sign-out-alt" />
                          <span>Logout</span>
                        </a>
                        <form id="logout-form" action="https://getonlinetrader.pro/otprocl/logout" method="POST" style={{ display: 'none' }}>
                          <input type="hidden" name="_token" defaultValue="ej8Cog6hsY5gfbuOV15ye7J7DbCjCQEOJgkrticJ" />
                        </form>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="collapse navbar-collapse navbar-collapse-fade" id="navbar-main-collapse">
                  <ul className="navbar-nav ml-lg-auto align-items-center d-none d-lg-flex">
                    <li className="nav-item">
                      <a href="#" className="nav-link nav-link-icon sidenav-toggler" data-action="sidenav-pin" data-target="#sidenav-main"><i className="far fa-bars" /></a>
                    </li>
                    <li className="nav-item dropdown dropdown-animate">
                      <a className="nav-link pr-lg-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className="media media-pill align-items-center">
                          <span className="avatar rounded-circle">
                            <i className="fas fa-user-circle fa-2x" />
                          </span>
                          <div className="ml-2 d-none d-lg-block">
                            <span className="mb-0 text-sm font-weight-bold">{userdetails.fullname}</span>
                          </div>
                        </div>
                      </a>
                      <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right dropdown-menu-arrow">
                        <h6 className="px-0 dropdown-header">Hi, {userdetails.fullname}!</h6>
                        <a href="/Dashboard/account-settings" className="dropdown-item">
                          <i className="far fa-user" />
                          <span>My profile</span>
                        </a>
                        <div className="dropdown-divider" />
                        <a className="dropdown-item text-danger" href="https://getonlinetrader.pro/otprocl/logout" onClick={(e) => { e.preventDefault(); document.getElementById('logout-form').submit(); }}>
                          <i className="far fa-sign-out-alt" />
                          <span>Logout</span>
                        </a>
                        <form id="logout-form" action="https://getonlinetrader.pro/otprocl/logout" method="POST" style={{ display: 'none' }}>
                          <input type="hidden" name="_token" defaultValue="ej8Cog6hsY5gfbuOV15ye7J7DbCjCQEOJgkrticJ" />
                        </form>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>

            {/* Page content */}
            <div className="page-content">
              <div className="page-title">
                <div className="row justify-content-between align-items-center">
                  <div className="mb-3 col-md-6 mb-md-0">
                    <h5 className="mb-0 text-white h3 font-weight-400">Fund your account balance</h5>
                  </div>
                </div>
              </div>

              <div className="row">

                {/* ── STEP 1 ── */}
                {step == 1 && (
                  <div className="col-md-12">
                    <div className="card ">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8">
                            <form action="javascript:;" method="post" id="submitpaymentform">
                              <input type="hidden" name="_token" defaultValue="ej8Cog6hsY5gfbuOV15ye7J7DbCjCQEOJgkrticJ" />
                              <div className="row">
                                <div className="mb-4 col-md-12">
                                  <h5 className="card-title ">Enter Amount</h5>
                                  <input className="form-control " placeholder="Enter Amount" min={5} type="number" name="amount" required onChange={(e) => setAmount(e.target.value)} />
                                </div>
                                <div className="mb-4 col-md-12">
                                  <input type="hidden" name="payment_method" id="paymethod" />
                                </div>
                                <div className="mt-2 mb-1 col-md-12">
                                  <h5 className="card-title ">Choose Payment Method from the list below</h5>
                                </div>

                                {/* ── Dynamic coins: rendered from Firestore, controlled by admin ── */}
                                {!coinsLoaded && (
                                  <div className="col-md-12 mb-3">
                                    <p className="text-muted"><i className="fas fa-spinner fa-spin mr-2" />Loading payment methods...</p>
                                  </div>
                                )}

                                {coinsLoaded && Coins.length === 0 && (
                                  <div className="col-md-12 mb-3">
                                    <div className="alert alert-warning">
                                      No payment methods are currently available. Please contact support.
                                    </div>
                                  </div>
                                )}

                                {coinsLoaded && Coins.map((coin) => (
                                  <div className="mb-2 col-md-6" key={coin.id}>
                                    <a style={{ cursor: 'pointer' }} className="text-decoration-none">
                                      <div
                                        className="rounded border"
                                        style={{
                                          borderColor: CoinInfo.id === coin.id ? '#5e72e4' : undefined,
                                          boxShadow: CoinInfo.id === coin.id ? '0 0 0 2px #5e72e4' : undefined,
                                        }}
                                      >
                                        <div className="card-body d-flex justify-content-between align-items-center">
                                          <span>
                                            <img
                                              src={coin.img}
                                              alt={coin.name}
                                              style={{ width: '25px', marginRight: '6px' }}
                                              onError={(e) => { e.target.style.opacity = '0.3' }}
                                            />
                                            {coin.name}
                                          </span>
                                          <span>
                                            <input
                                              type="radio"
                                              name="selectedcoin"
                                              readOnly
                                              checked={CoinInfo.id === coin.id}
                                              onClick={() => SetCoinInfo(coin.name)}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                ))}

                                <div className="mt-2 mb-1 col-md-12">
                                  <input type="button" className="px-5 btn btn-primary btn-lg" value="Procced to Payment" onClick={Proceed} />
                                </div>
                                <input type="hidden" id="lastchosen" defaultValue={0} />
                              </div>
                            </form>
                          </div>

                          {/* Summary sidebar */}
                          <div className="mt-4 col-md-4">
                            <div className="card">
                              <div className="card-body">
                                <div className="pb-4">
                                  <div className="row align-items-center">
                                    <div className="col-6">
                                      <h6 className="mb-0">Total Deposit</h6>
                                      <span className="text-sm text-muted">-</span>
                                    </div>
                                    <div className="col-6">
                                      <h6 className="mb-1">
                                        <b>${Amount}</b>
                                      </h6>
                                      <span className="text-sm text-muted">Amount</span>
                                    </div>
                                  </div>
                                  {CoinInfo && CoinInfo.name && (
                                    <div className="row align-items-center mt-3">
                                      <div className="col-6">
                                        <h6 className="mb-0">Payment Via</h6>
                                      </div>
                                      <div className="col-6 d-flex align-items-center">
                                        <img src={CoinInfo.img} alt={CoinInfo.name} style={{ width: '20px', marginRight: '6px' }} />
                                        <h6 className="mb-0"><b>{CoinInfo.name}</b></h6>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="card-footer">
                                <div className="actions d-flex justify-content-between">
                                  <a href="/Dashboard/accounthistory" className="action-item">
                                    <span className="btn-inner--icon">View deposit history</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ── STEP 2 ── */}
                {step == 2 && (
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-8 offset-md-2">
                            <div className="p-2 shadow-lg card p-md-4">
                              <div className="alert alert-modern alert-warning">
                                <span className="badge badge-warning badge-pill">
                                  Your payment method
                                </span>
                                <span className="alert-content">{CoinInfo.name}</span>
                              </div>
                              <div className="card-body">
                                <div>
                                  <h6 className>You are to make payment of
                                    <strong> ${Amount} </strong>
                                    using your selected payment method.
                                  </h6>
                                </div>
                                <div className="mt-5">
                                  <h6 className="mt-4">
                                    <strong>{CoinInfo.name} Address:</strong>
                                  </h6>
                                  <div className="mb-3 form-group">
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        className="form-control readonly"
                                        value={CoinInfo.address || ''}
                                        id="reflink"
                                        readOnly
                                      />
                                      <div className="input-group-append">
                                        <button className="btn btn-outline-secondary" onClick={copyAlert} type="button" id="button-addon2">
                                          <i className="fas fa-copy" />
                                        </button>
                                      </div>
                                    </div>
                                    <small>
                                      <strong>Network Type:</strong> {CoinInfo.network || CoinInfo.name}
                                    </small>
                                  </div>
                                </div>
                                <div>
                                  <form encType="multipart/form-data">
                                    <div className="form-group">
                                      <p className>Upload Payment proof after payment.</p>
                                      <input type="file" name="proof" className="form-control col-lg-8 " onChange={handleChange} required />
                                    </div>
                                    <input type="hidden" name="amount" defaultValue={Amount} />
                                    <input type="hidden" name="paymethd_method" defaultValue={CoinInfo.name} />

                                    {imagepresnt && (
                                      <>
                                        <progress id="file" value={progress} max="100"> {progress} </progress>
                                        <div className="form-group">
                                          <input type="button" className="btn btn-primary" value="Submit Payment" onClick={handleUpload} />
                                        </div>
                                      </>
                                    )}
                                    <div className="form-group">
                                      <input type="button" className="btn btn-primary" onClick={() => { setstep(1) }} value="Cancel" />
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>

            {/* Footer */}
            <div className="pt-5 pb-4 footer footer-light sticky-bottom" id="footer-main">
              <div className="text-center row text-sm-left align-items-sm-center">
                <div className="col-sm-6">
                  <p className="mb-0 text-sm">All Rights Reserved © PROFITCHAININVESTMENT 2026</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loading && (
          <div id="backdrop">
            <div className="text-center loading">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Deposit;

